export enum ParamsEnum {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  DATE = 'date',
  ARRAY_STRING = 'array_string',
  ARRAY_NUMBER = 'array_number',
  ARRAY_BOOLEAN = 'array_boolean',
}

export interface ParamsEnumMap {
  [ParamsEnum.NUMBER]: number;
  [ParamsEnum.STRING]: string;
  [ParamsEnum.BOOLEAN]: boolean;
  [ParamsEnum.DATE]: Date;
  [ParamsEnum.ARRAY_NUMBER]: number[];
  [ParamsEnum.ARRAY_STRING]: string[];
  [ParamsEnum.ARRAY_BOOLEAN]: boolean[];
}
